export function isActive(a,b){
    if(a===b)
        return 'active';
    return '';
}